/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Actiontextcount2Inputs */

const en_actiontextcount2 = /** @type {(inputs: Actiontextcount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const de_actiontextcount2 = /** @type {(inputs: Actiontextcount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

/**
* | output |
* | --- |
* | "{count}/{max}" |
*
* @param {Actiontextcount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actiontextcount2 = /** @type {((inputs: Actiontextcount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actiontextcount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actiontextcount2(inputs)
	return de_actiontextcount2(inputs)
});
export { actiontextcount2 as "actionTextCount" }